<script setup lang="ts">
import { Text } from '~ds/components/ui/typography';

interface Props {

  state: { [key: string]: any };
  fieldKey: string;
  hint?: string;
}
const props = defineProps<Props>();

const errorMessage = computed(() => {
  // Only show errors after the field has been blurred
  if (!props.state?.meta?.isBlurred) {
    return;
  }

  const errors = props.state?.meta?.errors;
  if (!Array.isArray(errors)) {
    return undefined;
  }

  const firstError = errors.find(e => Array.isArray(e.path) && e.path[0] === props.fieldKey);
  return firstError?.message;
});
</script>

<template>
  <div class="mt-1.5">
    <Text
      v-if="hint && !errorMessage"
      as="span"
      size="sm"
      class="text-muted-foreground"
    >
      {{ hint }}
    </Text>
    <!--
      role="alert" + aria-live so a reveal (a blocked submit blurring untouched fields) is
      announced, matching KUICoreInputErrors; the message can appear without any focus change.
    -->
    <Text
      v-if="errorMessage"
      size="sm"
      class="text-destructive"
      role="alert"
      aria-live="polite"
    >
      {{ errorMessage }}
    </Text>
  </div>
</template>
